import type { ReactNode } from 'react';

import { useEffect } from 'react';

import type { Theme } from '../store/theme';

import { useMediaQuery } from '../hooks/use-media-query';
import { useTheme } from '../hooks/use-theme';
import { THEMES } from '../store/theme';

export type ThemeProviderProps = {
    children: ReactNode;
    initialTheme?: Theme;
};

export function ThemeProvider({ children, initialTheme }: ThemeProviderProps) {
    const { theme, mode, setTheme } = useTheme();
    const isSystemDark = useMediaQuery('(prefers-color-scheme: dark)');

    useEffect(() => {
        if (initialTheme) {
            setTheme(initialTheme);
        }
    }, [initialTheme, setTheme]);

    useEffect(() => {
        const root = window?.document.documentElement;

        if (!root)
            return;

        const isDarkMode = mode === 'dark' || (mode === 'system' && isSystemDark);

        root.classList.toggle('dark', isDarkMode);

        root.classList.remove(...THEMES);

        if (theme && theme !== 'default') {
            root.classList.add(theme);
        }
    }, [theme, mode, isSystemDark]);

    return <>{children}</>;
}
